/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { savedOrderDetailsActionButtonsStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import { css } from "styled-components";

savedOrderDetailsActionButtonsStyles.deleteButton = {
    css: css`
        margin-left: 20px;
    `,
    variant: "secondary",
};

savedOrderDetailsActionButtonsStyles.addToListButton = savedOrderDetailsActionButtonsStyles.deleteButton;

savedOrderDetailsActionButtonsStyles.placeOrderButton = {
    css: css`
        margin-left: 20px;
    `,
};

savedOrderDetailsActionButtonsStyles.printButton = {
    variant: "secondary",
};
